import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ACCOUNT_EVENT_IDS } from '@central-products/interface-account-actions';
import { ErrorTypes, StateTypes, WelcomeMessagesFlowInterface } from '@central-products/interface-welcome-messages-flow';
import { CtaSectionType } from '@central-products/welcome-messages-types';
import { WelcomeMessagesFlowPopup } from './WelcomeMessagesFlowPopup';
import { trackAccepted, trackDismissed, trackDisplayed, trackInteraction } from './tracking';
import { translation } from './translations';
import { imageUrlToBlob } from '@central-products/image-converter';
import { getDeviceImageUrl, getDeviceResolution } from './utils';
import { WM_MESSAGE_TYPE } from './enums';
var fallback = {
  error: function error() {} // tslint:disable-line: no-empty

};
export var logger = typeof window !== 'undefined' && (window.consoleReference || window.console) || fallback;
export var WelcomeMessagesFlow = /*#__PURE__*/function (_WelcomeMessagesFlowI) {
  _inherits(WelcomeMessagesFlow, _WelcomeMessagesFlowI);

  var _super = _createSuper(WelcomeMessagesFlow);

  function WelcomeMessagesFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, WelcomeMessagesFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.NONE);

    _defineProperty(_assertThisInitialized(_this), "domNode", null);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "campaign", void 0);

    _defineProperty(_assertThisInitialized(_this), "campaignNumber", void 0);

    _defineProperty(_assertThisInitialized(_this), "optInPromise", void 0);

    _defineProperty(_assertThisInitialized(_this), "optInTimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "stateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "onUiDisplayed", function () {
      _this.dependencies['on-site-messaging-orchestrator'].requestMessage({
        type: WM_MESSAGE_TYPE.MESSAGE_SHOWN,
        payload: {
          campaign: _this.campaign,
          campaignNumber: _this.campaignNumber
        }
      });

      trackDisplayed(_this.campaign);

      _this.changeState(StateTypes.UI_DISPLAYED, {
        campaign: _this.campaign,
        campaignNumber: _this.campaignNumber
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDismissed", function (label) {
      trackDismissed(_this.campaign, label);

      _this.exit();
    });

    _defineProperty(_assertThisInitialized(_this), "cancelOptIn", function () {
      if (_this.optInPromise) {
        _this.optInPromise.reject();

        _this.optInPromise = undefined;
      }

      _this.exit();

      _this.dependencies['account-actions'].execute({
        eventId: ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_NAVIGATE_REQUESTED,
        context: {
          data: {
            url: _this.config.marketingPreferencePageUrl,
            target: '_self'
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "startOptInFlow", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.dependencies['welcome-messages-campaign-provider'].updateMarketingPreferences({
                  contactable: data.contactable,
                  contactables: data.contactables
                });

              case 3:
                _this.optInFinished({
                  succeed: true
                });

                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                logger.error(_context.t0);

                _this.optInFinished({
                  succeed: false
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "executeOptInRequested", function () {
      _this.optInTimeout = setTimeout(function () {
        _this.cancelOptIn();
      }, _this.config.optInTimeout);
      return new _Promise(function (resolve, reject) {
        _this.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_OPTIN_REQUESTED,
          context: {
            data: {
              contactable: true,
              contactables: {
                email: true
              }
            }
          }
        });

        _this.optInPromise = {
          resolve: resolve,
          reject: reject
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "executeNavigateRequested", function (url, target) {
      _this.dependencies['account-actions'].execute({
        eventId: ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_NAVIGATE_REQUESTED,
        context: {
          data: {
            url: url,
            target: target
          }
        }
      });

      trackAccepted(_this.campaign, url);

      _this.exit();
    });

    _defineProperty(_assertThisInitialized(_this), "onAccepted", function (_ref2) {
      var url = _ref2.url,
          target = _ref2.target,
          type = _ref2.type;

      if (type === CtaSectionType.OPTIN) {
        return _this.executeOptInRequested();
      } else {
        return _this.executeNavigateRequested(url, target);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInteraction", function (elementId, buttonLabel) {
      trackInteraction(_this.campaign, elementId, buttonLabel);
    });

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(WelcomeMessagesFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dependencies['on-site-messaging-orchestrator'].onMessageRequested(function (_ref3) {
                  var type = _ref3.type,
                      payload = _ref3.payload;

                  if (type === WM_MESSAGE_TYPE.CAMPAIGN) {
                    _this2.start(payload);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var campaign, campaignNumber, imageUrl, imgBlob, resolution;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                campaign = _ref4.campaign, campaignNumber = _ref4.campaignNumber;

                if (!(this.state !== StateTypes.NONE)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", {
                  error: ErrorTypes.INVALID_STATE
                });

              case 3:
                if (!(campaign === null || campaign === void 0 ? void 0 : campaign.imageSrc)) {
                  _context3.next = 18;
                  break;
                }

                imageUrl = getDeviceImageUrl(campaign.imageSrc);

                if (!imageUrl) {
                  _context3.next = 18;
                  break;
                }

                _context3.prev = 6;
                _context3.next = 9;
                return imageUrlToBlob({
                  url: imageUrl,
                  timeout: this.config.imageConversionReqTimeout
                });

              case 9:
                imgBlob = _context3.sent;
                resolution = getDeviceResolution();
                campaign.imageSrc[resolution] = imgBlob;
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](6);
                (window.consoleReference || window.console).error(_context3.t0);
                this.dependencies['on-site-messaging-orchestrator'].requestMessage({
                  type: WM_MESSAGE_TYPE.IMAGE_CONVERSION_FAILED
                });

              case 18:
                this.changeState(StateTypes.CAMPAIGN_REQUESTED, {
                  campaign: campaign,
                  campaignNumber: campaignNumber
                });
                this.campaign = campaign;
                this.campaignNumber = campaignNumber;
                this.render();
                this.changeState(StateTypes.UI_REQUESTED, {
                  campaign: this.campaign,
                  campaignNumber: this.campaignNumber
                });
                return _context3.abrupt("return", {});

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 14]]);
      }));

      function start(_x2) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.state === StateTypes.NONE)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", {
                  error: ErrorTypes.INVALID_STATE
                });

              case 2:
                this.exit();
                return _context4.abrupt("return", {});

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
    /**
     * @deprecated
     * Only for backward compatibility
     */

  }, {
    key: "uiDisplayed",
    value: function () {
      var _uiDisplayed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.state !== StateTypes.UI_REQUESTED)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", {
                  error: ErrorTypes.INVALID_STATE
                });

              case 2:
                this.changeState(StateTypes.UI_DISPLAYED);
                return _context5.abrupt("return", {});

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function uiDisplayed() {
        return _uiDisplayed.apply(this, arguments);
      }

      return uiDisplayed;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.stateChangedCallback = callback; // tslint:disable-next-line:no-empty

      return function () {};
    }
  }, {
    key: "optInFinished",
    value: function optInFinished(_ref5) {
      var succeed = _ref5.succeed;
      clearTimeout(this.optInTimeout);

      if (succeed) {
        this.optInPromise.resolve();
        this.optInPromise = undefined;
      } else {
        this.cancelOptIn();
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.domNode = document.createElement('div');
      document.body.appendChild(this.domNode);
      ReactDOM.render( /*#__PURE__*/React.createElement(WelcomeMessagesFlowPopup, _Object$assign({}, this.config, {
        campaign: this.campaign,
        onDisplayed: this.onUiDisplayed,
        onDismissed: this.onDismissed,
        onAccepted: this.onAccepted,
        onInteraction: this.onInteraction,
        congratulationScreenData: translation[this.config.langCode]
      })), this.domNode);
    }
  }, {
    key: "exit",
    value: function exit() {
      this.changeState(StateTypes.NONE);

      if (this.domNode) {
        ReactDOM.unmountComponentAtNode(this.domNode);
        document.body.removeChild(this.domNode);
        this.domNode = null;
      }
    }
  }, {
    key: "changeState",
    value: function changeState(state, payload) {
      this.state = state;

      if (typeof this.stateChangedCallback === 'function') {
        this.stateChangedCallback({
          state: state,
          payload: payload
        });
      }
    }
  }]);

  return WelcomeMessagesFlow;
}(WelcomeMessagesFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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